var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSliderMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.138,
    height: 12.138,
    viewBox: "0 0 12.138 12.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.138 10.79V1.349A1.353 1.353 0 0010.79 0H1.349A1.353 1.353 0 000 1.349v9.441a1.353 1.353 0 001.349 1.349h9.441a1.353 1.353 0 001.348-1.349zM3.709 7.081l1.686 2.03 2.36-3.041 3.035 4.046H1.349z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSliderMax);
export default __webpack_public_path__ + "static/media/img-slider-max.db5dca8d.svg";
export { ForwardRef as ReactComponent };